// createGroupStructureDown.js
export const createGroupStructureDown = (groupData, parsedSettings, groupKey) => {
  const selectedCapabilities = groupData.length >= 4 ? 3 : 8;

  const structure = {
    //+++=========================================+++
    // ++==Inicio Datos de Prueba DEMODIGITAL ==++
    // customerId: 144,
    // displayName: "Demo (Digital)",
    // accountCode: "0001",
    // ++== FIN Datos de Prueba DEMODIGITAL ==++
    //+++=========================================+++

    customerId: parsedSettings.clienteId,
    displayName: parsedSettings.displayName,
    accountCode: parsedSettings.accountCode,

    companyId: parsedSettings.companyId,
    paymentType: "Account",
    pickupDueTime: new Date(`${groupData[0].FechaProgramado}T${groupData[0].HoraProgramado}`),
    name: groupData[0].Nombre.toUpperCase(),
    passengers: groupData.length,
    telephoneNumber: groupData[0].Telefono,
    capabilities: [selectedCapabilities],
    accountType: "Account",
    driverNote: `ESPERAR (${groupData.length}) PAX (${groupData[0].Nombre.toUpperCase()}, ${groupData
      .slice(1)
      .map((pasajero) => pasajero.Nombre.toUpperCase())
      .join(", ")}) (TRASLADO ${groupData[0].NG}) CONDUCTOR: RESPETAR MEDIDAS DE SEGURIDAD (VELOCIDAD, NO USAR CELULAR`,
    priority: 5,
    pickup: {
      address: {
        text: groupData[0].origin.address.toUpperCase(),
        coordinate: {
          latitude: groupData[0].origin.latitude,
          longitude: groupData[0].origin.longitude,
        },
        street: groupData[0].origin.address.toUpperCase(),
      },
      passengerDetailsIndex: 0,
      type: "Pickup",
    },
    destination: {
      address: {
        text: groupData[groupData.length - 1].destination.address.toUpperCase(),
        zoneId: groupData[groupData.length - 1].destination.zoneId,
        coordinate: {
          latitude: groupData[groupData.length - 1].destination.latitude,
          longitude: groupData[groupData.length - 1].destination.longitude,
        },
        street: groupData[groupData.length - 1].destination.address.toUpperCase(),
      },
      note: "",
      passengerDetailsIndex: groupData.length - 1,
      type: "Destination",
    },
    priorityOverride: true,
    hold: true,
    yourReferences: {
      yourReference5: groupData[0].Solicitante,
      yourReference2: groupData[0].Rut,
      yourReference6: groupData
        .slice(1)
        .map((p) => `${p.Nombre}/${p.Rut}`.toUpperCase())
        .filter(Boolean)
        .join(" / "),
      yourReference3: groupData[0].NG,
      yourReference4: groupData[0].OS,
      yourReference7: groupData[0].Motivo,
    },
  };

  if (groupData.length > 1) {
    structure.vias = [
      {
        address: {
          text: groupData[0].origin.address.toUpperCase(),
          coordinate: {
            latitude: groupData[0].origin.latitude,
            longitude: groupData[0].origin.longitude,
          },
          street: groupData[0].origin.address.toUpperCase(),
        },
        note: "",
        passengerDetailsIndex: 1,
        type: "Pickup",
      },
      ...groupData.slice(1, groupData.length - 1).map((pasajero, index) => ({
        address: {
          text: pasajero.origin.address.toUpperCase(),
          coordinate: {
            latitude: pasajero.origin.latitude,
            longitude: pasajero.origin.longitude,
          },
          street: pasajero.origin.address.toUpperCase(),
        },
        note: "",
        passengerDetailsIndex: index + 2,
        type: "Pickup",
      })),
      {
        address: {
          text: groupData[0].destination.address.toUpperCase(),
          coordinate: {
            latitude: groupData[0].destination.latitude,
            longitude: groupData[0].destination.longitude,
          },
          street: groupData[0].destination.address.toUpperCase(),
        },
        note: "",
        passengerDetailsIndex: 0,
        type: "Pickup",
      },
      ...groupData.slice(1, groupData.length - 1).map((pasajero, index) => ({
        address: {
          text: pasajero.destination.address.toUpperCase(),
          coordinate: {
            latitude: pasajero.destination.latitude,
            longitude: pasajero.destination.longitude,
          },
          street: pasajero.destination.address.toUpperCase(),
        },
        note: "",
        passengerDetailsIndex: index + 1,
        type: "Pickup",
      })),
    ];

    structure.extraPassengerDetails = groupData.slice(1).map((pasajero, index) => ({
      customerId: parsedSettings.clienteId,
      driverNote: "",
      dropOffTime: null,
      name: `${pasajero.Nombre.toUpperCase()} / ${pasajero.Rut}`,
      ourReference: index + 1,
      pickupDueTime: new Date(`${pasajero.FechaProgramado}T${pasajero.HoraProgramado}`).toISOString(),
      ringTextRequests: 0,
      telephoneNumber: pasajero.Telefono,
      yourReference: "",
      hasDestination: false,
    }));
  }

  return structure;
};
